import PremiumModal from './PremiumModal'

export default PremiumModal
